"use client";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from "react";
import { Divider as ChakraDivider, forwardRef } from "@chakra-ui/react";
import { DividerLook } from "./Divider.types";
import { lookToColor } from "./Divider.helpers";
const Divider = forwardRef((_a, ref) => {
    var { look = DividerLook.PRIMARY } = _a, props = __rest(_a, ["look"]);
    const borderColor = useMemo(() => look && lookToColor(look), [look]);
    return _jsx(ChakraDivider, Object.assign({ ref: ref, borderColor: borderColor }, props));
});
Divider.displayName = "Divider";
export default Divider;
//# sourceMappingURL=Divider.js.map